import { render, staticRenderFns } from "./CustomerContactPersonEditPopup.vue?vue&type=template&id=1b705a25&"
import script from "./CustomerContactPersonEditPopup.vue?vue&type=script&lang=js&"
export * from "./CustomerContactPersonEditPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports